import React from 'react';
import Footer1 from '../components/Footer1';
import Header1 from '../components/Header1';

import turnKey from '../assets/img/turnKey-3.jpg';

function TurnKeyProject() {
    return (
        <>
            <Header1 />
                <section className='blog-wrapper news-wrapper section-padding'>
                    <div className='container'>
                        <div className='row'>
                            <div className="col-md-12">
                                <div className="news-content">
                                    <div className="section-heading">
                                        <p className='mb-0'><strong>Turn Key</strong> Project</p><h5 className='mb-0 pb-0'></h5><p></p>
                                    </div>
                                    <div className='row'>
                                        <div className="col-md-6">
                                            <p>
                                                </p><ul>
                                                    <li className='li-arrow'>Blood Bank</li>
                                                    <li className='li-arrow'>cGMP Laboratory</li>
                                                    <li className='li-arrow'>BMT unit</li>
                                                    <li className='li-arrow'>Cord Blood Bank</li>
                                                    <li className='li-arrow'>cGMP product manufacturing consulation</li>
                                                    <li className='li-arrow'>Equipment supply and services</li>
                                                    <li className='li-arrow'>Quality control program (Cell Processing)</li>
                                                    <li className='li-arrow'>Training Program for Technicians / Nurses (BMT Related)</li>
                                                </ul>
                                            <p></p>
                                        </div>
                                        <div className="col-md-6 pt-5">
                                            <img src={turnKey} className="alignleft img-responsive" alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            <Footer1 />
        </>
    );
}

export default TurnKeyProject;
